import { render, staticRenderFns } from "./whatsapp-button.vue?vue&type=template&id=4f533090&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./whatsapp-button.vue?vue&type=script&lang=js&"
export * from "./whatsapp-button.vue?vue&type=script&lang=js&"
import style0 from "./whatsapp-button.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f533090')) {
      api.createRecord('4f533090', component.options)
    } else {
      api.reload('4f533090', component.options)
    }
    module.hot.accept("./whatsapp-button.vue?vue&type=template&id=4f533090&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&", function () {
      api.rerender('4f533090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/whatsapp-button.vue"
export default component.exports